export default {
	Register: "Register",
	LoginAsManager: "LoginAsManager",
};
